import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
const ResponsePage = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  const fetchResponses = () => {
    setLoading(true);
    fetch("/api/get_responses.php")
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setNotifications(data.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  const deleteResponse = (id) => {

    fetch("/api/delete_responses.php", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: `id=${id}`
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setNotifications(notifications.filter((n) => n.id !== id));
        } 
      })
  };

  useEffect(() => {
    fetchResponses();
  }, []);

  if (loading)
    return (
      <div className="text-center text-white mt-10 text-2xl">Բեռնում է...</div>
    );

  if (notifications.length === 0)
    return (
      <div className="text-center text-white mt-10 text-2xl">
        {t("youarenotresponse")}
      </div>
    );

  return (
    <table className="w-[1000px] max-lg:w-full p-6 max-md:p-2 mx-auto py-12 mt-6 rounded-2xl shadow-2xl backdrop-blur-2xl flex flex-col gap-3">
      <h1 className="text-3xl max-md:text-xl opacity-0 animate-[showtitle_1s_forwards] text-start w-full text-white mb-6 uppercase font-semibold">
       {t("Listofsubmitted")}
      </h1>

      {notifications.map((item) => (
        <tr
          key={item.id}
          className="flex w-full opacity-0 animate-[showtitle_1s_forwards] p-3 justify-between items-center rounded-[20px] shadow-2xl bg-white"
        >
          <td className="w-max flex justify-start items-center">
            <img
              className="w-[80px] max-md:w-[60px] object-contain max-md:h-[60px] h-[80px] bg-gray-300 rounded-xl"
              src={item.companyLogo}
              alt={item.companyName || "Компания"}
            />
          </td>

          <td className="w-max flex justify-center max-md:flex-col max-md:items-start items-center">
            <h1 className="text-2xl max-md:text-lg">{item.companyName || "Компания"}</h1>
            <h1 className="text-xl md:hidden max-md:text-sm">{item.vacancy_title}</h1>
          </td>

          <td className="w-max max-md:hidden flex justify-center items-center">
            <h1 className="text-xl max-md:text-sm">{item.vacancy_title}</h1>
          </td>

          <td className="w-max flex justify-center max-md:hidden items-center">
            <h1 className="text-xl max-md:text-sm">{new Date(item.created_at).toLocaleDateString()}</h1>
          </td>

          <td className="w-max flex justify-center max-md:flex-col max-md:items-start items-center">
            <h1 className="text-xl md:hidden max-md:text-sm">{new Date(item.created_at).toLocaleDateString()}</h1>
            <h1 className="text-xl max-md:text-sm">
              {new Date(item.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
            </h1>
          </td>

          <td className="w-max flex justify-center items-center">
            <button
              className="w-[40px] bg-red-600 text-white h-[40px] flex justify-center items-center rounded-full"
              onClick={() => deleteResponse(item.id)}
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </td>
        </tr>
      ))}
    </table>
  );
};

export default ResponsePage;
